import React from 'react'
import APIRouteChainConfig from "@system/chain/api-route-chain";

const APIRouteChain = () => {
  return (
    <div className={'container-fluid-plp p-2'}>
            <table className="table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>URL</th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {Object.entries(APIRouteChainConfig.chain).map((v) => (
                    <tr>
                        <td>{v[1].name}</td>
                        <td>{v[1].slug}</td>
                        <td>
                        </td>
                    </tr>
                ))
                }
                </tbody>
            </table>
        </div>
  )
}

export default APIRouteChain